import { allowedZones } from '@portal-root/geo-utils';

const FORBIDDEN_SYMBOLS_REG_EXP = /[^а-яА-Я\w-./:+?=&;]/;
const DOMAIN_WHITE_LIST =
  process.env.NEXT_PUBLIC_DOMAIN_WHITE_LIST ||
  'seller|seller-stage|seller-portal-stage|seller-portal-stage-ru|portal-sam-stage|cmp-stage|adsf-web-stage|ads-outdoor-lk-stage|mfe.adp|rost-stage';

export const checkIsWbMask = (url: string): boolean => {
  // check if the url is relative
  if (url.startsWith('/')) {
    // additional check if url doesn't include double slash or forbidden symbols that shouldn't be in the url
    return !url.startsWith('//') && !FORBIDDEN_SYMBOLS_REG_EXP.test(url);
  }

  if (!DOMAIN_WHITE_LIST) {
    return false;
  }

  const computedWhiteList = allowedZones
    .map((zone) => {
      return DOMAIN_WHITE_LIST.split('|')
        .map((projectName) => `https://${projectName}${zone}/`)
        .join('|');
    })
    .join('|');

  // add escape slash before each special char as it's necessary in RegExp constructor
  const escapedUrl = computedWhiteList.replace(/[-[\]{}()*+?.,\\^$#]/g, '\\$&');

  const regexp = new RegExp(`^(${escapedUrl}).*$`);

  return regexp.test(url);
};
